// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"widget-layout_pageContainer__1wG76","popupWrapper":"widget-layout_popupWrapper__32jNe"};